import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const incompatiblePressureVacuumSettingsHardRule: StowageRuleBM = {
    id: StowageRuleId.IncompatiblePressureVacuumSettingsHardRule,
    name: 'A cargo for which the IBC chapter 15.14 applies should not be stowed in a tank without cooling and with a maximum pressure under 0.6 bar.',
    lastUpdatedUtc: '2024-08-25T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                operator: BooleanOperator.AND,
                children: [
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Cargo property product.category.isAnnexIIChapter17',
                                    fieldPath: 'cargo.product.category.isAnnexIIChapter17',
                                    type: 'boolean',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'boolean',
                                    referenceValue: 'true',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Equals,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category specific and operational requirements',
                                    fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'IBC chapter 15.14',
                                    type: 'string',
                                    referenceValue: 'IBC-15.14',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Contains,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Tank property tank.hasCooling',
                                    fieldPath: 'tank.hasCooling',
                                    type: 'boolean',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'boolean',
                                    referenceValue: 'false',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Equals,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Tank property tank.maxVapourPressure',
                                    fieldPath: 'tank.maxVapourPressure',
                                    type: 'number',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'number',
                                    referenceValue: '0.6',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.IsLessThan,
                        },
                    },
                ],
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Cargo subject to IBC 15.14 must be stowed in a tank that has cooling capacity or in a tank with a max vapor pressure ≥ 0.6 bar',
    },
};
